var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{class:{
	'window-stack-view': true,
	active: _vm.popups.length > 0
},attrs:{"name":"list"}},_vm._l((_vm._popups),function(p,i){return _c(p.component,_vm._b({key:i,tag:"component",staticClass:"popup",style:({
		top: 	p.top,
		right: 	p.right,
		left: 	p.left
	}),on:{"pop":function($event){return _vm.$emit('pop')}},nativeOn:{"click":function($event){$event.stopPropagation();}}},'component',p,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }